import moment from 'moment-timezone';
export default function (value, filterFormat) {
  const timezone = 'America/New_York';
  const format = 'LL';
  if (value) {
    return moment(value).tz(timezone).format(filterFormat || format || 'lll');
  }
  return '';
}